import BeeIcon from 'components/icons/svg/BeeIcon';
import BoltIcon from 'components/icons/svg/BoltIcon';
import BoyIcon from 'components/icons/svg/BoyIcon';
import CapIcon from 'components/icons/svg/CapIcon';
import ChanelIcon from 'components/icons/svg/ChanelIcon';
import CoffeeIcon from 'components/icons/svg/CoffeeIcon';
import CrowdFireIcon from 'components/icons/svg/CrowdFireIcon';
import CrownIcon from 'components/icons/svg/CrownIcon';
import DebugIcon from 'components/icons/svg/DebugIcon';
import DollarIcon from 'components/icons/svg/DollarIcon';
import DribbleIcon from 'components/icons/svg/DribbleIcon';
import BowlIcon from 'components/icons/svg/GhostIcon';
import GiftIcon from 'components/icons/svg/GiftIcon';
import GirlIcon from 'components/icons/svg/GirlIcon';
import GlassIcon from 'components/icons/svg/GlassIcon';
import GlobeAltIcon from 'components/icons/svg/GlobeAltIcon';
import GlobeIcon from 'components/icons/svg/GlobeIcon';
import PacmanIcon from 'components/icons/svg/PacmanIcon';
import PillIcon from 'components/icons/svg/PillIcon';
import SunIcon from 'components/icons/svg/SunIcon';
import SwissIcon from 'components/icons/svg/SwissIcon';
import TerrainIcon from 'components/icons/svg/TerrainIcon';
import TrophyIcon from 'components/icons/svg/TrophyIcon';
import UmbrellaIcon from 'components/icons/svg/UmbrellaIcon';
import YinYangIcon from 'components/icons/svg/YinYangIcon';
import React from 'react';

export enum ICON {
  Bee = 'bee',
  Bolt = 'bolt',
  Boy = 'boy',
  Cap = 'cap',
  Chanel = 'chanel',
  Coffee = 'coffee',
  CrowdFire = 'crowdfire',
  Crown = 'crown',
  Debug = 'debug',
  Dollar = 'dollar',
  Dribble = 'dribble',
  Ghost = 'ghost',
  Gift = 'gift',
  Girl = 'girl',
  Glass = 'glass',
  Globe = 'globe',
  GlobeAlt = 'globealt',
  Pacman = 'pacman',
  Pill = 'pill',
  Sun = 'sun',
  Swiss = 'swiss',
  Terrain = 'terrain',
  Trophy = 'trophy',
  Umbrella = 'umbrella',
  YinYang = 'yinyang',
}

export const renderIcon = (
  icon: string,
  size: number = 24,
  color: string = '#fffff0',
  className = ''
): React.ReactNode => {
  switch (icon) {
    case ICON.Bee:
      return <BeeIcon size={size} color={color} className={className} />;
    case ICON.Bolt:
      return <BoltIcon size={size} color={color} className={className} />;
    case ICON.Boy:
      return <BoyIcon size={size} color={color} className={className} />;
    case ICON.Cap:
      return <CapIcon size={size} color={color} className={className} />;
    case ICON.Chanel:
      return <ChanelIcon size={size} color={color} className={className} />;
    case ICON.Coffee:
      return <CoffeeIcon size={size} color={color} className={className} />;
    case ICON.CrowdFire:
      return <CrowdFireIcon size={size} color={color} className={className} />;
    case ICON.Crown:
      return <CrownIcon size={size} color={color} className={className} />;
    case ICON.Dribble:
      return <DribbleIcon size={size} color={color} className={className} />;
    case ICON.Dollar:
      return <DollarIcon size={size} color={color} className={className} />;
    case ICON.Debug:
      return <DebugIcon size={size} color={color} className={className} />;
    case ICON.Ghost:
      return <BowlIcon size={size} color={color} className={className} />;
    case ICON.Gift:
      return <GiftIcon size={size} color={color} className={className} />;
    case ICON.Girl:
      return <GirlIcon size={size} color={color} className={className} />;
    case ICON.Glass:
      return <GlassIcon size={size} color={color} className={className} />;
    case ICON.Globe:
      return <GlobeIcon size={size} color={color} className={className} />;
    case ICON.GlobeAlt:
      return <GlobeAltIcon size={size} color={color} className={className} />;
    case ICON.Pacman:
      return <PacmanIcon size={size} color={color} className={className} />;
    case ICON.Pill:
      return <PillIcon size={size} color={color} className={className} />;
    case ICON.Sun:
      return <SunIcon size={size} color={color} className={className} />;
    case ICON.Swiss:
      return <SwissIcon size={size} color={color} className={className} />;
    case ICON.Terrain:
      return <TerrainIcon size={size} color={color} className={className} />;
    case ICON.Trophy:
      return <TrophyIcon size={size} color={color} className={className} />;
    case ICON.Umbrella:
      return <UmbrellaIcon size={size} color={color} className={className} />;
    case ICON.YinYang:
      return <YinYangIcon size={size} color={color} className={className} />;

    default:
      return icon;
  }
};
